import styled from "styled-components";
// import ZoomIcon from "assets/svgIcons/ZoomIcon";
import ZoomIcon from "assets/images/zoomIcon.png";
export const Header = styled.div`
  padding: 13px 20px;
  display: flex;
  align-items: center;
  gap: 10px 0;
  background: var(--filter-bar-bg);
  flex-wrap: wrap;
  > .label-wrapper {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 0 10px;
    border-left: 1px solid #cdcfd0;
    .MuiNativeSelect-select {
      padding-left: 13px;
    }
    .MuiInputBase-root {
      border-radius: 6px;
      font-family: inherit;
      font-size: 13px;
      ::before {
        display: none;
      }
    }
    .label-p {
      font-size: 13px;
      line-height: 16px;
      margin-right: 5px;
      color: #fff;
    }
    svg {
      cursor: pointer;
    }
    :first-child {
      border: none;
    }
    button {
      display: flex;
      align-items: center;
      gap: 12px;
      border: 1px solid var(--filter-bar-bg);
      border-radius: 6px;
      background: var(--theme-text);
      height: 30px;
      padding: 0 8px;
      font-size: 13px;
      &.active {
        color: var(--theme-text);
        background: var(--theme-background);
        border: var(--theme-background);
      }
    }
    .dropdown {
      background-color: var(--theme-text);
      border-radius: 6px;
    }

    /* .active-rotation {
      display: flex;
      min-width: 170px;
      max-width: 170px;
      border: 1px solid #cdcfd0;
      border-radius: 6px;
      background: transparent;
      position: relative;
      height: 30px;
      align-items: center;
      padding-left: 8px;
      .MuiSelect-outlined.MuiSelect-outlined {
        padding-top: 0;
        padding-bottom: 0;
        color: transparent;
      }
      .MuiSelect-iconOutlined {
        background-color: transparent;
      }
      .MuiOutlinedInput-notchedOutline,
      .MuiInputLabel-root {
        display: none;
      }
      .MuiFormControl-root {
        width: 100%;
      }
      .text {
        position: absolute;
        font-size: 13px;
      }
    } */
  }
`;

export const Container = styled.div`
  overflow: auto;
`;



export const BodySection = styled.div`
  padding: 0 20px 46px;
  background: #fafafa4d;
  position: relative;
`;

export const BodyHeader = styled.div`
  padding: 18px 0;
  border-bottom: 1px solid #c2c2c2;
  display: flex;
  justify-content: space-between;
  .d-flex-wrapper {
    display: flex;
    gap: 12px;
    align-items: center;
  }
  h4 {
    font-size: 18px;
    line-height: 150.5%;
    font-family: "latobold";
  }
`;

export const MainSection = styled.div`
  display: flex;
  gap: 50px;
  .full-image-wrapper {
    position: relative;
    ::after {
      content: "";
      display: inline-block;
      width: 1px;
      height: 100%;
      position: absolute;
      right: -23px;
      top: 0;
      bottom: 0;
      background: #c2c2c2;
    }
  }
  .full-image-wrapper,
  .insert-image-wrapper {
    position: relative;
    min-height: calc(100vh - 227px);
    flex: 1;
    .head {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 15px 0;
      h6 {
        font-size: 16px;
        line-height: 150.5%;
        font-family: "latobold";
      }
      .checkbox {
        label {
          flex-direction: row-reverse;
          .MuiCheckbox-root {
            padding-left: 10px;
          }
          .MuiTypography-root {
            font-size: 13px;
            line-height: 16px;
          }
        }
      }
    }
    .image-main-wrapper {
      overflow: auto;
      padding: 10px;
      max-height: calc(100vh - 280px);
      display: flex;
      gap: 30px 40px;
      flex-wrap: wrap;
      align-items: flex-start;
      > .image-wrapper {
        position: relative;
        width: 300px;
        /* min-height: 200px; */
        border-radius: 10px;
        border: 1px solid rgba(0, 0, 0, 0.15);
        box-shadow: 2px 4px 15px rgba(0, 0, 0, 0.15);
        /* overflow: hidden; */
        .des {
          color: black;
          position: absolute;
          top: 0;
        }
        .custom-position.Mui-checked ~ img {
          opacity: 0.9;
        }
        .overlay {
          position: absolute;
          right: 0;
          top: 0;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 7px 11px;
          align-items: flex-end;
          .edit-wrapper {
            display: flex;
            align-items: center;
            gap: 10px;
            button {
              border: 1px solid #ffffff;
              border-radius: 3px;
              background: #00000099;
              width: 20px;
              height: 20px;
              display: inline-flex;
              justify-content: center;
              align-items: center;
              cursor: pointer;
              padding: 0;
            }
          }
        }
        .imgTitle {
          font-weight: 500;
          font-size: 12px;
          padding: 10px 64px 10px 38px;
          word-break: break-word;
        }
        .uploadedDateInfo {
          /* position: absolute; */
          bottom: 0;
          right: 0;
          font-style: normal;
          font-weight: 500;
          font-size: 13px;
          padding: 0 12px 12px;
        }
        img {
          max-width: 100%;
          width: 100%;
          height: 100%;
          padding: 5px 10px 15px 10px;
          border-radius: 20px;
          min-height: 182px;
        }
        .imageSubtitle {
          margin: 0px 10px;
        }
      }
    }
  }
`;

export const AddNewImageWrapper = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  background: #ffffff;
  box-shadow: 0px 4px 15px rgb(0 0 0 / 25%);
  z-index: 3;
  width: 304px;
  padding: 0 20px;
  .heading {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #d1d0cb;
    h2 {
      font-size: 18px;
      line-height: 150.5%;
      padding: 12px 0;
      font-family: "latobold";
    }
    svg {
      cursor: pointer;
      transform: rotate(45deg);
    }
  }
  .label-tag {
    font-size: 14px;
    line-height: 150.5%;
    margin-bottom: 9px;
    font-family: "latobold";
  }
  .wrapper {
    margin-top: 20px;
  }
  .field-container {
    margin-bottom: 30px;
    .image-wrapper {
      display: flex;
      align-items: center;
      gap: 13px;

      .selected-image {
        border-radius: 10px;
        max-width: 60%;
        max-height: 50%;
        min-width: 40%;
        min-height: 50%;
        width: 100%;
      }
      .image-title {
        font-size: 11px;
        line-height: 150.5%;
      }
    }
  }
  .field {
    position: relative;
    input {
      background: #ffffff;
      border: 1px solid #cdcfd0;
      border-radius: 6px;
      width: 100%;
      height: 30px;
      padding: 0 54px 0 13px;
    }

    .upload-icon {
      position: absolute;
      right: 16px;
      top: 5px;
    }
  }
  .title-field {
    input {
      height: 50px;
      padding: 0 13px;
    }
  }
  .action-wrapper {
    display: flex;
    align-items: center;
    gap: 10px;
    button {
      min-width: 64px;
    }
  }
`;

export const PreviewImageWrapper = styled.div`
  padding-top: 59%;
  /* min-width: 500px; */
  position: relative;
  img {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
  }
`;
